import React, {useEffect} from 'react';
import {Button, Card, Modal, Space, Table} from 'antd';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {ArticleApi, UserApi, UserDto} from '../../scaffold';
import {useAntdTable} from 'ahooks';
import AntDTableUtils from '../../utils/AntDTableUtils';
import {DefaultAntdTableConfig} from '../../utils/CommonConfig';
import moment from 'moment';
import UserViewBtn from '../../components/user/ViewBtn';
import UserEditBtn from '../../components/user/EditBtn';
import EditManagerForm from '../../components/user/EditManagerForm';
import {useBoolean} from 'react-hanger';

export default function ManageManagerListPage() {
  const listHook = useOpenApiFpRequest(UserApi, UserApi.prototype.userListManagerGet);
  useEffect(() => {
    listHook.requestSync({});
  }, []);
  const isDialogAdd = useBoolean(false);

  return (
    <div className={'p-20'}>
      <Card
        title={'专委会管理员列表'}
        extra={
          <Space>
            <Button type={'primary'} onClick={isDialogAdd.setTrue}>
              添加账户
            </Button>
          </Space>
        }>
        <Table dataSource={listHook.data} loading={listHook.loading} pagination={{showTotal: v => `共 ${v} 条`}} size={'small'} bordered>
          <Table.Column title={'ID'} dataIndex={'id'} sorter key={'id'} />
          <Table.Column title={'专委会名称'} dataIndex={['telephone']} />
          <Table.Column<UserDto>
            title={'操作选项'}
            render={(_, item) => (
              <Space>
                {/*<UserViewBtn user={item} size={'small'}>*/}
                {/*  查看*/}
                {/*</UserViewBtn>*/}
                {/*<UserEditBtn user={item} size={'small'} onSuccess={antdConfig.refresh}>*/}
                {/*  编辑*/}
                {/*</UserEditBtn>*/}
              </Space>
            )}
          />
        </Table>
        <Modal width={600} destroyOnClose visible={isDialogAdd.value} onCancel={isDialogAdd.setFalse} footer={null} title={'添加专委会负责人'}>
          <EditManagerForm
            onSuccess={() => {
              isDialogAdd.setFalse();
              listHook.requestSync({});
            }}
            onCancel={isDialogAdd.setFalse}
          />
        </Modal>
      </Card>
    </div>
  );
}
